export enum TableActionColor {
    primary,
    accent,
    warn
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/table/table-action-color.enum.ts